import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {get, ref, set} from 'firebase/database';
import {db} from '@/firebase';
import {IRoll} from '@/types/Roll';
import {Game} from '@/types/Interfaces';
import {NormalRoll} from '@/types/NormalRoll';

@Component
export class MJMixin extends Vue {
    @Prop() game!: Game;
    secret = false;
    normalRollText = '';
    npcs: boolean[] = [];

    async rollNormal(): Promise<void> {
        const roll = new NormalRoll(this.secret, this.game.type, 'MJ');
        roll.roll(this.normalRollText);

        let mjRolls: IRoll[] | null = null;
        await get(ref(db, `/jdrs/${this.game.id}/characters/${this.$store.state.user.uid}/rolls`)).then(snap => {
            mjRolls = snap.val();
        });
        if (mjRolls === null) mjRolls = [];
        mjRolls = [roll, ...mjRolls];
        mjRolls = mjRolls.slice(0, 25);
        await set(ref(db, `/jdrs/${this.game.id}/characters/${this.$store.state.user.uid}/rolls`), mjRolls);

        let globalRolls: IRoll[] | null = null;
        await get(ref(db, `/jdrs/${this.game.id}/rolls`)).then(snap => {
            globalRolls = snap.val();
        });
        if (globalRolls === null) globalRolls = [];
        globalRolls = [roll, ...globalRolls];
        globalRolls = globalRolls.slice(0, 100);
        await set(ref(db, `/jdrs/${this.game.id}/rolls`), globalRolls);
    }

    getGroups(): { name: string, npcs: any[] }[] {
        const ret: { name: string, npcs: any[] }[] = [];
        if (this.game.groups) {
            this.game.groups.forEach(group => {
                const pnjs = Object.values(this.game.characters).filter(char => {
                    return char.isNPC && char.category === group && char.isDisplayed;
                });
                if (pnjs.length > 0) ret.push({name: group, npcs: pnjs});
            });
        }
        return ret;
    }

    @Watch('game.turnOrder') onTurnOrderChange(): void {
        if (this.game.turnOrder.isStarted && this.game.turnOrder.isActive) {
            this.npcs.forEach((value, index) => {
                if (value) {
                    Vue.set(this.npcs, index, false);
                }
            });
            Vue.set(this.npcs, parseInt(this.game.turnOrder.characters[0].id), true);
        }
    }
}
 